export default __webpack_public_path__ + "static/media/the_venue_1.780dfc0e.png";